<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <side-bar
                :background-color="sidebarBackground"
        >
            <template slot="links">
<!--                <sidebar-item :link="{name: 'Dashboard',icon: 'ni ni-sound-wave text-primary',path: '/dashboard'}"/>-->
                <sidebar-item :link="{name: 'Code',icon: 'fas fa-qrcode text-primary',path: '/code'}"/>
                <sidebar-item :link="{name: 'Background',icon: 'fas fa-mountain text-primary',path: '/background'}"/>
                <sidebar-item :link="{name: 'Setting',icon: 'fas fa-cog text-primary',path: '/setting'}"/>


                <li class="nav-item" v-if="isLogged" @click="logout">
                    <a class="nav-link">
                        <i class="ni ni-button-power text-primary"></i>
                        <span class="nav-link-text"> ออกจากระบบ </span>
                    </a>
                </li>


            </template>
        </side-bar>
        <div class="main-content" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>

            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <router-view></router-view>
                </fade-transition>


                <slideout-panel></slideout-panel>

            </div>
        </div>
    </div>
</template>
<script>

    import {mapState} from 'vuex';
    import store from '../store';

    import DashboardNavbar from './DashboardNavbar.vue';
    import {FadeTransition} from 'vue2-transitions';
    import {SIGN_OUT} from "../store/actions.type";

    export default {
        components: {
            DashboardNavbar,
            FadeTransition
        },
        computed: {
            ...mapState({
                isLogged: state => state.auth.isLogged,
            },),
        },
        data() {
            return {
                sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
            };
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
            logout() {
                store.dispatch(SIGN_OUT).then(() => {
                    this.$router.push('/login');
                })
            }
        }
    };
</script>
<style lang="scss">
    .nav-item{
        cursor: pointer;
    }
</style>
